import {
  type RequiredTargetingSectionKeysType,
  TargetingElementKeys,
  type TargetingSettingsContextType,
} from '../../../../context/types';
import type { useElementOperations } from '../../../../hooks/useElementOperations';

export const enableTVDevices = (
  sectionKey: RequiredTargetingSectionKeysType,
  set: TargetingSettingsContextType['setState'],
  enableElementByKey: ReturnType<typeof useElementOperations>['enableElementByKey']
) => {
  set(prev => {
    const updated = enableElementByKey(prev.sections[sectionKey].elements, TargetingElementKeys.DEVICE_TV);

    return {
      ...prev,
      sections: {
        ...prev.sections,
        [sectionKey]: {
          ...prev.sections[sectionKey],
          elements: updated,
        },
      },
    };
  });
};
